module.exports = __webpack_public_path__ + "static/img/nlogo.c8f4a1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nlogo.png
// module id = kD47
// module chunks = 1